import React, { Component } from 'react'
import { withCookies, Cookies } from 'react-cookie'
import Linkify from 'react-linkify'
import ImageZoom from 'react-medium-image-zoom'
import {
    getThumbnailSVG,
    RoleStr,
    renderFiles,
    renderPDFFiles,
    renderImageFiles,
    renderOfficeFiles,
    renderVideoFiles,
} from '../Commons/Utils'
import { CommentReportBtn } from './CommentReportBtn'

class ChildItem extends Component {
    render() {
        const user = this.props.user
        const items = this.props.comments.childComments

        return items.map((item, j) => {
            const newDate = new Date(item.createdAt)
            const newYear = newDate.getFullYear()

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }
            let newHours = newDate.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            let thumbnail = ''
            if (item.writer && item.writer.thumbnailUrl) {
                thumbnail = <img src={item.writer.thumbnailUrl} alt="profile" />
            } else {
                thumbnail = getThumbnailSVG(item.writer.group)
            }

            let imageFiles = <></>
            if (item.files) {
                imageFiles = item.files
                    .map((item, index) => {
                        if (item.url && item.url.match(/.(jpg|jpeg|png|gif)$/i)) {
                            return <ImageZoom image={{ src: item.url }} alt="comment_img" />
                        }
                    })
                    .filter((notUndefined) => notUndefined !== undefined)
            }

            let linkFiles = <></>
            if (item.files) {
                linkFiles = (
                    <div className="text_wrap">
                        <div className="content" style={{ paddingLeft: '0' }}>
                            {renderFiles(item.files)}
                        </div>
                    </div>
                )
            }

            return (
                <div
                    id={'child_wrap' + this.props.parentIndex + '_' + j}
                    key={this.props.parentIndex + '_' + j}
                    className="child_wrap item_wrap">
                    {!(item.reInput.modify === true) && (
                        <div className={item.isRemoved === false ? 'content_wrap' : 'content_wrap remove_content_wrap'}>
                            <ul className="date">
                                <li>
                                    {newYear}.{newMonth}.{newDay}
                                </li>
                                <li className="line"></li>
                                <li>
                                    {newHours}:{newMinutes}
                                </li>
                            </ul>
                            <svg
                                className="child_icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 12 14">
                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#BEC6D2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.3">
                                    <path d="M1 1.5v6.673h9.995" />
                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                </g>
                            </svg>
                            <div className="user">
                                <div className="thumbnail">{thumbnail}</div>
                                <p className="name">
                                    {' '}
                                    {RoleStr[item.writer.group]} {item.writer.name}
                                </p>
                            </div>

                            {!(item.reInput.modify === true && !item.parentUser) && (
                                <Linkify>
                                    <pre className="content">
                                        {item.parentUser && <span>@ {item.parentUser.name} </span>}
                                        {item.isRemoved ? (
                                            <div>삭제된 댓글입니다.</div>
                                        ) : item.isReported ? <div>신고된 댓글입니다.</div> : (
                                            <div>
                                                {' '}
                                                {item.content} {linkFiles}
                                                {imageFiles}
                                            </div>
                                        )}
                                    </pre>
                                </Linkify>
                            )}

                            {item.isRemoved === false && !(item.reInput.modify === true && !item.parentUser) && (
                                <div>
                                    <div className='right-box'>
                                        {!item.isReported && <CommentReportBtn commentId={item._id} content={item.content} loadComment={this.props.loadComment} />}

                                        <div
                                            className="reply_btn"
                                            onClick={() => this.props.openReInput(this.props.parentIndex, j)}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 12 14">
                                                <g
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    stroke="#BEC6D2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3">
                                                    <path d="M1 1.5v6.673h9.995" />
                                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                                </g>
                                            </svg>
                                            댓글
                                        </div>
                                    </div>

                                    {item.writer._id === user._id && (
                                        <ul className="btn_ul">
                                            <li
                                                className="comment_delete_btn"
                                                onClick={() => this.props.clickDeletebtn(this.props.parentIndex, j)}>
                                                삭제
                                            </li>
                                            <li className="line"></li>
                                            <li
                                                className="comment_modify_btn"
                                                onClick={() => this.props.openModify(this.props.parentIndex, j)}>
                                                수정
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {item.reInput.modify ? (
                        <div
                            className={
                                item.reInput.focus
                                    ? 'focus input_wrap recomment_re_input_wrap modify_input'
                                    : 'blur input_wrap recomment_re_input_wrap modify_input'
                            }>
                            <svg
                                className="child_icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="14"
                                viewBox="0 0 12 14">
                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#A2A7AE"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.3">
                                    <path d="M1 1.5v6.673h9.995" />
                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                </g>
                            </svg>
                            <textarea
                                placeholder="댓글을 입력하세요"
                                type="text"
                                name="content"
                                value={item.reInput.content}
                                onChange={(event) => this.props.reChangeData(event, this.props.parentIndex, j)}
                                onFocus={() => this.props.reOnFocus(this.props.parentIndex, j)}
                            />
                            <div
                                className="add_btn"
                                onClick={() => this.props.modifyComment(this.props.parentIndex, j)}>
                                수정하기
                            </div>
                            {item.reInput.focus && (
                                <div>
                                    <div
                                        className="input_cancel_btn"
                                        onClick={() => this.props.reOnBlur(this.props.parentIndex, j)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#BEC6D2"
                                                strokeLinecap="round"
                                                strokeWidth="1.7">
                                                <path d="M1 15L15 1M1 1l14 14" />
                                            </g>
                                        </svg>
                                    </div>

                                    {item.reInput.files && item.reInput.files.length > 0 && (
                                        <div className="input_img_wrap">
                                            <img src={item.reInput.files[0].url} alt="img" />
                                            <svg
                                                onClick={() => this.props.reDeleteFile(this.props.parentIndex, j)}
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28">
                                                <defs>
                                                    <circle id="cancel_btn1" cx="14" cy="14" r="12" />
                                                    <filter
                                                        id="cancel_btn2"
                                                        width="125%"
                                                        height="125%"
                                                        x="-12.5%"
                                                        y="-12.5%"
                                                        filterUnits="objectBoundingBox">
                                                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                        <feGaussianBlur
                                                            in="shadowOffsetOuter1"
                                                            result="shadowBlurOuter1"
                                                            stdDeviation="1"
                                                        />
                                                        <feComposite
                                                            in="shadowBlurOuter1"
                                                            in2="SourceAlpha"
                                                            operator="out"
                                                            result="shadowBlurOuter1"
                                                        />
                                                        <feColorMatrix
                                                            in="shadowBlurOuter1"
                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                                                        />
                                                    </filter>
                                                </defs>
                                                <g fill="none" fillRule="evenodd">
                                                    <g fill="#000">
                                                        <use filter="url(#cancel_btn2)" xlinkHref="#cancel_btn1" />
                                                        <circle
                                                            cx="14"
                                                            cy="14"
                                                            r="11"
                                                            fillOpacity=".55"
                                                            stroke="#FFF"
                                                            strokeLinejoin="square"
                                                            strokeWidth="2"
                                                        />
                                                    </g>
                                                    <path
                                                        stroke="#FFF"
                                                        strokeLinecap="round"
                                                        strokeWidth="1.7"
                                                        d="M10.437 17.516l7.079-7.08M10.437 10.437l7.079 7.079"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                    )}

                                    <div className="img_add_btn">
                                        <label htmlFor={'file' + this.props.parentIndex + '_' + j}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16">
                                                <g fill="none" fillRule="evenodd" stroke="#A2A7AE">
                                                    <rect
                                                        width="14.7"
                                                        height="14.7"
                                                        x=".65"
                                                        y=".65"
                                                        strokeWidth="1.3"
                                                        rx="2"
                                                    />
                                                    <circle
                                                        cx="5.143"
                                                        cy="5.143"
                                                        r="1.714"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.2"
                                                    />
                                                    <path
                                                        strokeLinecap="square"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3"
                                                        d="M14.857 10.494L10.93 6.857l-8.643 8"
                                                    />
                                                </g>
                                            </svg>
                                            사진첨부
                                        </label>
                                        <input
                                            id={'file' + this.props.parentIndex + '_' + j}
                                            type="file"
                                            name={'file' + this.props.parentIndex + '_' + j}
                                            accept="image/*"
                                            onChange={(e) => this.props.reFileUpload(e, this.props.parentIndex, j)}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div
                            className={
                                item.reInput.focus
                                    ? 'focus input_wrap recomment_re_input_wrap'
                                    : 'blur input_wrap recomment_re_input_wrap'
                            }>
                            <svg
                                className="child_icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 12 14">
                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#BEC6D2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.3">
                                    <path d="M1 1.5v6.673h9.995" />
                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                </g>
                            </svg>
                            <textarea
                                placeholder={'@' + ' ' + item.writer.name}
                                type="text"
                                name="content"
                                value={item.reInput.content}
                                onChange={(event) => this.props.reChangeData(event, this.props.parentIndex, j)}
                                onFocus={() => this.props.reOnFocus(this.props.parentIndex, j)}
                            />
                            <div className="add_btn" onClick={() => this.props.addComment(this.props.parentIndex, j)}>
                                댓글달기
                            </div>
                            {item.reInput.focus && (
                                <div>
                                    <div
                                        className="input_cancel_btn"
                                        onClick={() => this.props.reOnBlur(this.props.parentIndex, j)}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16">
                                            <g
                                                fill="none"
                                                fillRule="evenodd"
                                                stroke="#BEC6D2"
                                                strokeLinecap="round"
                                                strokeWidth="1.7">
                                                <path d="M1 15L15 1M1 1l14 14" />
                                            </g>
                                        </svg>
                                    </div>

                                    {item.reInput.files && item.reInput.files.length > 0 && (
                                        <div className="input_img_wrap">
                                            <img src={item.reInput.files[0].url} alt="img" />
                                            <svg
                                                onClick={() => this.props.reDeleteFile(this.props.parentIndex, j)}
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28">
                                                <defs>
                                                    <circle id="cancel_btn1" cx="14" cy="14" r="12" />
                                                    <filter
                                                        id="cancel_btn2"
                                                        width="125%"
                                                        height="125%"
                                                        x="-12.5%"
                                                        y="-12.5%"
                                                        filterUnits="objectBoundingBox">
                                                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                        <feGaussianBlur
                                                            in="shadowOffsetOuter1"
                                                            result="shadowBlurOuter1"
                                                            stdDeviation="1"
                                                        />
                                                        <feComposite
                                                            in="shadowBlurOuter1"
                                                            in2="SourceAlpha"
                                                            operator="out"
                                                            result="shadowBlurOuter1"
                                                        />
                                                        <feColorMatrix
                                                            in="shadowBlurOuter1"
                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                                                        />
                                                    </filter>
                                                </defs>
                                                <g fill="none" fillRule="evenodd">
                                                    <g fill="#000">
                                                        <use filter="url(#cancel_btn2)" xlinkHref="#cancel_btn1" />
                                                        <circle
                                                            cx="14"
                                                            cy="14"
                                                            r="11"
                                                            fillOpacity=".55"
                                                            stroke="#FFF"
                                                            strokeLinejoin="square"
                                                            strokeWidth="2"
                                                        />
                                                    </g>
                                                    <path
                                                        stroke="#FFF"
                                                        strokeLinecap="round"
                                                        strokeWidth="1.7"
                                                        d="M10.437 17.516l7.079-7.08M10.437 10.437l7.079 7.079"
                                                    />
                                                </g>
                                            </svg>
                                        </div>
                                    )}

                                    <div className="img_add_btn">
                                        <label htmlFor={'file' + this.props.parentIndex + '_' + j}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16">
                                                <g fill="none" fillRule="evenodd" stroke="#A2A7AE">
                                                    <rect
                                                        width="14.7"
                                                        height="14.7"
                                                        x=".65"
                                                        y=".65"
                                                        strokeWidth="1.3"
                                                        rx="2"
                                                    />
                                                    <circle
                                                        cx="5.143"
                                                        cy="5.143"
                                                        r="1.714"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.2"
                                                    />
                                                    <path
                                                        strokeLinecap="square"
                                                        strokeLinejoin="round"
                                                        strokeWidth="1.3"
                                                        d="M14.857 10.494L10.93 6.857l-8.643 8"
                                                    />
                                                </g>
                                            </svg>
                                            사진첨부
                                        </label>
                                        <input
                                            id={'file' + this.props.parentIndex + '_' + j}
                                            type="file"
                                            name={'file' + this.props.parentIndex + '_' + j}
                                            accept="image/*"
                                            onChange={(e) => this.props.reFileUpload(e, this.props.parentIndex, j)}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )
        })
    }
}

class Comment extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        const ret =
            JSON.stringify(this.props.comments) !== JSON.stringify(nextProps.comments) ||
            JSON.stringify(this.props.index) !== JSON.stringify(nextProps.index)
        return ret
    }

    

    render() {
        const newDate = new Date(this.props.comments.createdAt)
        const newYear = newDate.getFullYear()

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }
        let newHours = newDate.getHours()
        if (newHours < 10) {
            newHours = '0' + newHours
        }
        let newMinutes = newDate.getMinutes()
        if (newMinutes < 10) {
            newMinutes = '0' + newMinutes
        }

        let thumbnail = ''
        if (this.props.comments.writer && this.props.comments.writer.thumbnailUrl) {
            thumbnail = <img src={this.props.comments.writer.thumbnailUrl} alt="profile" />
        } else {
            thumbnail = getThumbnailSVG(this.props.comments.writer.group)
        }

        let imageFiles = <></>
        if (this.props.comments.files) {
            imageFiles = this.props.comments.files
                .map((item, index) => {
                    if (item.url && item.url.match(/.(jpg|jpeg|png|gif)$/i)) {
                        return <ImageZoom image={{ src: item.url }} alt="comment_img" />
                    }
                })
                .filter((notUndefined) => notUndefined !== undefined)
        }

        let linkFiles = <></>
        if (this.props.comments.files) {
            linkFiles = (
                <div className="text_wrap">
                    <div className="content file_link" style={{ paddingLeft: '0' }}>
                        {renderFiles(this.props.comments.files)}
                    </div>
                </div>
            )
        }

        return (
            <div
                id={'item_wrap' + this.props.index}
                className={this.props.comments.parentUser ? 'child_wrap item_wrap' : 'parent_wrap item_wrap'}>
                {!(this.props.comments.reInput.modify === true && this.props.comments.parentUser) && (
                    <div
                        className={
                            this.props.comments.isRemoved === false
                                ? 'content_wrap'
                                : 'content_wrap remove_content_wrap'
                        }>
                        <ul className="date">
                            <li>
                                {newYear}.{newMonth}.{newDay}
                            </li>
                            <li className="line"></li>
                            <li>
                                {newHours}:{newMinutes}
                            </li>
                        </ul>
                        {this.props.comments.parentUser && (
                            <svg
                                className="child_icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="14"
                                viewBox="0 0 12 14">
                                <g
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#BEC6D2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.3">
                                    <path d="M1 1.5v6.673h9.995" />
                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                </g>
                            </svg>
                        )}
                        <div className="user">
                            <div className="thumbnail">{thumbnail}</div>
                            <p className="name">
                                {' '}
                                {RoleStr[this.props.comments.writer.group]} {this.props.comments.writer.name}
                            </p>
                        </div>

                        {!(this.props.comments.reInput.modify === true && !this.props.comments.parentUser) && (
                            <Linkify>
                                <pre className="content">
                                    {this.props.comments.parentUser && (
                                        <span>@ {this.props.comments.parentUser.name} </span>
                                    )}
                                    {this.props.comments.isRemoved ? (
                                        <div>삭제된 댓글입니다.</div>
                                    ) : this.props.comments.isReported ?  <div>신고된 댓글입니다.</div> : (
                                        <div>
                                            {this.props.comments.content} {linkFiles}
                                            {imageFiles}
                                        </div>
                                    )}
                                </pre>
                            </Linkify>
                        )}

                        {this.props.comments.isRemoved === false &&
                            !(this.props.comments.reInput.modify === true && !this.props.comments.parentUser) && (
                                <div>
                                    <div className='right-box'>
                                        {!this.props.comments.isReported &&
                                            <CommentReportBtn commentId={this.props.comments._id} content={this.props.comments.content} loadComment={this.props.loadComment} />
                                         }

                                        <div
                                            className="reply_btn"
                                            onClick={() => this.props.openReInput(this.props.index, -1)}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="10"
                                                height="10"
                                                viewBox="0 0 12 14">
                                                <g
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    stroke="#BEC6D2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3">
                                                    <path d="M1 1.5v6.673h9.995" />
                                                    <path d="M7 3.9l4.329 4.329L7 12.558" />
                                                </g>
                                            </svg>
                                            댓글
                                        </div>
                                    </div>

                                    {this.props.comments.writer._id === this.props.user._id && (
                                        <ul className="btn_ul">
                                            <li
                                                className="comment_delete_btn"
                                                onClick={() => this.props.clickDeletebtn(this.props.index, -1)}>
                                                삭제
                                            </li>
                                            <li className="line"></li>
                                            <li
                                                className="comment_modify_btn"
                                                onClick={() => this.props.openModify(this.props.index, -1)}>
                                                수정
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            )}
                    </div>
                )}

                {this.props.comments.reInput.modify ? (
                    <div
                        className={
                            this.props.comments.reInput.focus
                                ? 'focus input_wrap recomment_input_wrap modify_input'
                                : 'blur input_wrap recomment_input_wrap modify_input'
                        }>
                        <svg
                            className="child_icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="14"
                            viewBox="0 0 12 14">
                            <g
                                fill="none"
                                fillRule="evenodd"
                                stroke="#A2A7AE"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.3">
                                <path d="M1 1.5v6.673h9.995" />
                                <path d="M7 3.9l4.329 4.329L7 12.558" />
                            </g>
                        </svg>
                        <textarea
                            placeholder="댓글을 입력하세요"
                            type="text"
                            name="content"
                            value={this.props.comments.reInput.content}
                            onChange={(event) => this.props.reChangeData(event, this.props.index, -1)}
                            onFocus={() => this.props.reOnFocus(this.props.index, -1)}
                        />
                        <div className="add_btn" onClick={() => this.props.modifyComment(this.props.index, -1)}>
                            수정하기
                        </div>
                        {this.props.comments.reInput.focus && (
                            <div>
                                <div
                                    className="input_cancel_btn"
                                    onClick={() => this.props.reOnBlur(this.props.index, -1)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#BEC6D2"
                                            strokeLinecap="round"
                                            strokeWidth="1.7">
                                            <path d="M1 15L15 1M1 1l14 14" />
                                        </g>
                                    </svg>
                                </div>

                                {this.props.comments.reInput.files && this.props.comments.reInput.files.length > 0 && (
                                    <div className="input_img_wrap">
                                        <img src={this.props.comments.reInput.files[0].url} alt="img" />
                                        <svg
                                            onClick={() => this.props.reDeleteFile(this.props.index, -1)}
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="28"
                                            height="28"
                                            viewBox="0 0 28 28">
                                            <defs>
                                                <circle id="cancel_btn1" cx="14" cy="14" r="12" />
                                                <filter
                                                    id="cancel_btn2"
                                                    width="125%"
                                                    height="125%"
                                                    x="-12.5%"
                                                    y="-12.5%"
                                                    filterUnits="objectBoundingBox">
                                                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                    <feGaussianBlur
                                                        in="shadowOffsetOuter1"
                                                        result="shadowBlurOuter1"
                                                        stdDeviation="1"
                                                    />
                                                    <feComposite
                                                        in="shadowBlurOuter1"
                                                        in2="SourceAlpha"
                                                        operator="out"
                                                        result="shadowBlurOuter1"
                                                    />
                                                    <feColorMatrix
                                                        in="shadowBlurOuter1"
                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                                                    />
                                                </filter>
                                            </defs>
                                            <g fill="none" fillRule="evenodd">
                                                <g fill="#000">
                                                    <use filter="url(#cancel_btn2)" xlinkHref="#cancel_btn1" />
                                                    <circle
                                                        cx="14"
                                                        cy="14"
                                                        r="11"
                                                        fillOpacity=".55"
                                                        stroke="#FFF"
                                                        strokeLinejoin="square"
                                                        strokeWidth="2"
                                                    />
                                                </g>
                                                <path
                                                    stroke="#FFF"
                                                    strokeLinecap="round"
                                                    strokeWidth="1.7"
                                                    d="M10.437 17.516l7.079-7.08M10.437 10.437l7.079 7.079"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                )}

                                <div className="img_add_btn">
                                    <label htmlFor={'file' + this.props.index}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16">
                                            <g fill="none" fillRule="evenodd" stroke="#A2A7AE">
                                                <rect
                                                    width="14.7"
                                                    height="14.7"
                                                    x=".65"
                                                    y=".65"
                                                    strokeWidth="1.3"
                                                    rx="2"
                                                />
                                                <circle
                                                    cx="5.143"
                                                    cy="5.143"
                                                    r="1.714"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.2"
                                                />
                                                <path
                                                    strokeLinecap="square"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3"
                                                    d="M14.857 10.494L10.93 6.857l-8.643 8"
                                                />
                                            </g>
                                        </svg>
                                        사진첨부
                                    </label>
                                    <input
                                        id={'file' + this.props.index}
                                        type="file"
                                        name={'file' + this.props.index}
                                        accept="image/*"
                                        onChange={(e) => this.props.reFileUpload(e, this.props.index, -1)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div
                        className={
                            this.props.comments.reInput.focus
                                ? 'focus input_wrap recomment_input_wrap'
                                : 'blur input_wrap recomment_input_wrap'
                        }>
                        <svg
                            className="child_icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 12 14">
                            <g
                                fill="none"
                                fillRule="evenodd"
                                stroke="#BEC6D2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1.3">
                                <path d="M1 1.5v6.673h9.995" />
                                <path d="M7 3.9l4.329 4.329L7 12.558" />
                            </g>
                        </svg>
                        <textarea
                            placeholder={'@' + ' ' + this.props.comments.writer.name}
                            type="text"
                            name="content"
                            value={this.props.comments.reInput.content}
                            onChange={(event) => this.props.reChangeData(event, this.props.index, -1)}
                            onFocus={() => this.props.reOnFocus(this.props.index, -1)}
                        />
                        <div className="add_btn" onClick={() => this.props.addComment(this.props.index, -1)}>
                            댓글달기
                        </div>
                        {this.props.comments.reInput.focus && (
                            <div>
                                <div
                                    className="input_cancel_btn"
                                    onClick={() => this.props.reOnBlur(this.props.index, -1)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#BEC6D2"
                                            strokeLinecap="round"
                                            strokeWidth="1.7">
                                            <path d="M1 15L15 1M1 1l14 14" />
                                        </g>
                                    </svg>
                                </div>

                                {this.props.comments.reInput.files && this.props.comments.reInput.files.length > 0 && (
                                    <div className="input_img_wrap">
                                        <img src={this.props.comments.reInput.files[0].url} alt="img" />
                                        <svg
                                            onClick={() => this.props.reDeleteFile(this.props.index, -1)}
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="28"
                                            height="28"
                                            viewBox="0 0 28 28">
                                            <defs>
                                                <circle id="cancel_btn1" cx="14" cy="14" r="12" />
                                                <filter
                                                    id="cancel_btn2"
                                                    width="125%"
                                                    height="125%"
                                                    x="-12.5%"
                                                    y="-12.5%"
                                                    filterUnits="objectBoundingBox">
                                                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                    <feGaussianBlur
                                                        in="shadowOffsetOuter1"
                                                        result="shadowBlurOuter1"
                                                        stdDeviation="1"
                                                    />
                                                    <feComposite
                                                        in="shadowBlurOuter1"
                                                        in2="SourceAlpha"
                                                        operator="out"
                                                        result="shadowBlurOuter1"
                                                    />
                                                    <feColorMatrix
                                                        in="shadowBlurOuter1"
                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                                                    />
                                                </filter>
                                            </defs>
                                            <g fill="none" fillRule="evenodd">
                                                <g fill="#000">
                                                    <use filter="url(#cancel_btn2)" xlinkHref="#cancel_btn1" />
                                                    <circle
                                                        cx="14"
                                                        cy="14"
                                                        r="11"
                                                        fillOpacity=".55"
                                                        stroke="#FFF"
                                                        strokeLinejoin="square"
                                                        strokeWidth="2"
                                                    />
                                                </g>
                                                <path
                                                    stroke="#FFF"
                                                    strokeLinecap="round"
                                                    strokeWidth="1.7"
                                                    d="M10.437 17.516l7.079-7.08M10.437 10.437l7.079 7.079"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                )}

                                <div className="img_add_btn">
                                    <label htmlFor={'file' + this.props.index}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16">
                                            <g fill="none" fillRule="evenodd" stroke="#A2A7AE">
                                                <rect
                                                    width="14.7"
                                                    height="14.7"
                                                    x=".65"
                                                    y=".65"
                                                    strokeWidth="1.3"
                                                    rx="2"
                                                />
                                                <circle
                                                    cx="5.143"
                                                    cy="5.143"
                                                    r="1.714"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.2"
                                                />
                                                <path
                                                    strokeLinecap="square"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3"
                                                    d="M14.857 10.494L10.93 6.857l-8.643 8"
                                                />
                                            </g>
                                        </svg>
                                        사진첨부
                                    </label>
                                    <input
                                        id={'file' + this.props.index}
                                        type="file"
                                        name={'file' + this.props.index}
                                        accept="image/*"
                                        onChange={(e) => this.props.reFileUpload(e, this.props.index, -1)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <ChildItem
                    loadComment={this.props.loadComment}
                    comments={this.props.comments}
                    user={this.props.user}
                    addComment={this.props.addComment}
                    deleteComment={this.props.deleteComment}
                    modifyComment={this.props.modifyComment}
                    openReInput={this.props.openReInput}
                    openModify={this.props.openModify}
                    closeReInput={this.props.closeReInput}
                    reChangeData={this.props.reChangeData}
                    reOnFocus={this.props.reOnFocus}
                    reOnBlur={this.props.reOnBlur}
                    reFileUpload={this.props.reFileUpload}
                    reDeleteFile={this.props.reDeleteFile}
                    clickDeletebtn={this.props.clickDeletebtn}
                    parentIndex={this.props.index}
                />
            </div>
        )
    }
}

export default withCookies(Comment)



// WEBPACK FOOTER //
// ./Src/Components/Commons/CommentItem.js